import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { Suspendable } from '@components';
import { ROUTES } from '@constants';

const CampaignMonitorReport = Suspendable(
  lazy(() =>
    import('@modules/campaignMonitorReport/controller/CampaignMonitorReportController').then(
      (module) => ({
        default: module.default,
      })
    )
  )
);

export const CampaignMonitorRoutes: RouteObject[] = [
  {
    element: <CampaignMonitorReport />,
    path: ROUTES.CAMPAIGN_MONITOR_REPORT.ROOT,
  },
];
